import axios from "../../privateApi";

interface EvoArgs {
  id: number;
  categoryId: number;
}

export const markEvoComplete = ({ id, categoryId }: EvoArgs) => {
  if (id == null || categoryId == null) return Promise.reject("Missing ids");
  return axios.post("/evolutions/completed", { id, categoryId });
};

export const markEvoUncomplete = ({ id, categoryId }: EvoArgs) => {
  if (id == null || categoryId == null) return Promise.reject("Missing ids");
  return axios.delete("/evolutions/completed", {
    data: { id, categoryId },
  });
};
